import {
  Button,
  Dialog,
  DialogActions,
  DialogContent,
  DialogContentText,
  Divider,
  FormHelperText,
  MenuItem,
  Paper,
  Select,
} from "@mui/material"
import { FC, useEffect, useState } from "react"

import { useAppDispatch, useAppSelector } from "@/core/app/hooks"
import { RootState } from "@/core/app/store"
import WorkflowDropdown from "./WorkflowDropdown"
import { updateCaseById } from "@/core/app/slices/case/caseThunkApi"
import { updatePatientRecordsForAssignPopup } from "@/core/app/slices/patients"


const ChangeWorkflowPopup: FC<{ setIsAlertOpen: (val: string) => void, assignedTo?: number, phaseId?: number, patientId?: string, caseId?: string, isReloadCallBack?: () => void }> = ({ setIsAlertOpen, assignedTo, phaseId, patientId, caseId, isReloadCallBack  }) => {

  const { doctorList } = useAppSelector((state: RootState) => state.doctorService)
  const dispatch = useAppDispatch()
  const { workflow } = useAppSelector((state:RootState)=> state.userService)
  
  const [assignedUser, setAssignedUser] = useState<number | null>(assignedTo)
  const [phase, setPhase] = useState<number | null>(phaseId)

  const handleWorkflowChange = (value: number) => {
    setPhase(value)
  }

  const handleAssignUserChange = (value: string | number) => {
    setAssignedUser(value === "" ? null : Number(value))
  }
  const [doctors, setDoctors] = useState<{ name: string; id: number }[]>([])
  const [staffs, setStaffs] = useState<{ name: string; id: number }[]>([])
  const [validationMode, setValidationMode] = useState<boolean>(false)

  useEffect(()=>{
    if(phase===phaseId) return
    setPhase(phaseId)
  }, [phaseId])

  useEffect(() => {
    const doc: typeof doctors = []
    const staff: typeof staffs = []

    doctorList.forEach(({ category, first_name, last_name, id }) => {
      const fullName = `${first_name} ${last_name}`
      const numericId = Number(id)
      category === "Doctors" ? doc.push({ name: fullName, id: numericId }) : staff.push({ name: fullName, id: numericId })
    })

    setDoctors(doc)
    setStaffs(staff)
  }, [doctorList])


  const handleSave = () => {
    if (assignedUser && phase && patientId && caseId) {
      dispatch(
        updateCaseById({
          patientId: patientId,
          caseId: caseId,
          payload: {
            assigned_to: assignedUser,
            phase: phase,
          },
        }),
      ).then((response)=>{
        if(location.pathname==="/patients"){
          dispatch(updatePatientRecordsForAssignPopup({
            patientId: Number(patientId),
            phase: response.payload.phase,
            assignedTo: response.payload.assigned_to
          }))
        }
        isReloadCallBack && isReloadCallBack()
      })
      setIsAlertOpen('')
    } else {
      console.error('Missing required fields:', { assignedUser, phase, patientId, caseId })
      setValidationMode(true)
    }
  }

  return (
    <Dialog open>
      <Paper sx={{ width: 444, maxWidth: "100%" }}>
        <DialogContent sx={{ pb: 1 }}>
          <DialogContentText sx={{ py: 1, color: "text.primary" }}>
            Assign to
          </DialogContentText>

          <Select
            value={assignedUser ?? ""}
            fullWidth
            displayEmpty
            onChange={(e) => handleAssignUserChange(e.target.value)}
            error={!!(validationMode && !assignedUser)}
          >
            <FormHelperText sx={{ px: 2 }}>Doctors</FormHelperText>
            {doctors.map(({ name, id }) => (
              <MenuItem key={id} value={id}>
                {name}
              </MenuItem>
            ))}
            <Divider />
            <FormHelperText sx={{ px: 2 }}>Staffs</FormHelperText>
            {staffs.map(({ name, id }) => (
              <MenuItem key={id} value={id}>
                {name}
              </MenuItem>
            ))}
          </Select>
          <WorkflowDropdown
            workflowId={phase}
            onChange={handleWorkflowChange}
            validationMode={validationMode}
          />
        </DialogContent>

        <DialogActions>
          <Button
            onClick={() => {
              setIsAlertOpen('false')
              //   dispatch(setShouldCloseTab(false))
            }}
            sx={{ textTransform: "uppercase" }}
          >
            Cancel
          </Button>
          <Button
            onClick={handleSave}
            variant="contained"
            color="primary"
            sx={{ textTransform: "uppercase" }}
          >
            Save
          </Button>
        </DialogActions>
      </Paper>
    </Dialog>
  )
}

export default ChangeWorkflowPopup
